<template>
  <div :class="{ 'personal-management': !isMobile, 'personal-mobile': isMobile }">
    <div class="header" v-show="!isMobile || currentModule === 'info'">
      <div class="title" v-if="isMobile">
        <div class="border_bottom">个人中心</div>
      </div>
      <div class="user-info" v-if="!isMobile">
        <label class="uploadlogoButton" for="headPhoto">
          <img class="head-pic" :src="headPic ? headPic : require('@imgs/personalPage/head-pic.png')" />
        </label>
        <input type="file" id="headPhoto" ref="headPhoto" value="imgFile" accept="image/png, image/jpg, image/jpeg" @change="uploadPhoto($event)" style="display: none" />
        <div class="name">
          <span>你好，</span>
          <span ref="nameSpan" contenteditable="true" v-html="userName" />
        </div>
        <el-button v-if="!isMobile" class="head-button" @click="changeUserName()">保存</el-button>
      </div>
      <div class="user-info" v-else>
        <img class="head-pic" :src="headPic ? headPic : require('@imgs/personalPage/head-pic.png')" />
        <div class="name">
          <span>你好，{{ userName }}</span>
        </div>
      </div>
      <ul class="navbar">
        <li class="border_bottom" @click="changeModule('orderRec')" :class="{ active: currentModule === 'orderRec' }">我的订阅记录</li>
        <li v-if="!isMobile" @click="changePassword">修改密码</li>
        <li class="border_bottom" v-if="isMobile" @click="changeInfo">修改信息</li>
        <!--<li class="border_bottom">用户协议</li>-->
        <li class="border_bottom" @click="logout">退出登录</li>
      </ul>
    </div>
    <div class="personal-management-content">
      <div class="side-bar" v-if="!isMobile">
        <div class="collect-bar" @click="changeModule('collect')" :class="{ active: currentModule === 'collect' }">
          <img :src="currentModule === 'collect' ? require('@imgs/personalPage/collect-icon.png') : require('@imgs/personalPage/collect-icon1.png')" />
          <span>我的收藏</span>
        </div>
        <div class="collect-bar" @click="changeModule('order')" :class="{ active: currentModule === 'order' }">
          <img :src="currentModule === 'order' ? require('@imgs/personalPage/order-icon.png') : require('@imgs/personalPage/order-icon1.png')" />
          <span>我的订阅</span>
        </div>
      </div>
      <div class="content">
        <my-collection module="collect" v-show="currentModule === 'collect'" title="我的收藏"></my-collection>
        <my-collection module="order" v-show="currentModule === 'order'" title="我的订阅"></my-collection>
        <my-collection module="orderRec" @goBack="changeModule" v-show="currentModule === 'orderRec'" title="我的订阅记录"></my-collection>
      </div>
      <user-info
        v-if="isMobile"
        ref="userInfo"
        v-show="currentModule === 'userInfo'"
        @goBack="changeModule"
        @uploadPhoto="uploadPhoto"
        @savePassword="savePassword"
        @changeUserName="changeUserName"
      ></user-info>
      <mobile-invoice-list v-if="currentModule === 'invoice'" :title="invoiceListTitle" />
    </div>
    <div v-if="isMobile && currentModule !== 'invoice'" class="mobile-button" v-show="currentModule !== 'orderRec' && currentModule !== 'userInfo'">
      <div class="button-item" @click="changeModule('order')">
        <div class="icon-wrapper">
          <img :src="currentModule === 'order' ? require('@imgs/personalPage/order-icon3.png') : require('@imgs/personalPage/order-icon2.png')" />
        </div>
        <div class="text">
          我的订阅
        </div>
      </div>
      <div class="button-item" @click="changeModule('collect')">
        <div class="icon-wrapper">
          <img :src="currentModule === 'collect' ? require('@imgs/personalPage/collect-icon3.png') : require('@imgs/personalPage/collect-icon2.png')" />
        </div>
        <div class="text">
          我的收藏
        </div>
      </div>
      <div class="button-item" @click="changeModule('info')">
        <div class="icon-wrapper">
          <img :src="currentModule === 'info' ? require('@imgs/personalPage/personal1.png') : require('@imgs/personalPage/personal.png')" />
        </div>
        <div class="text">
          个人中心
        </div>
      </div>
    </div>
    <password-dialog ref="passwordDialog" v-if="!isMobile" @savePassword="savePassword"></password-dialog>
  </div>
</template>
<script>
import { isLogin } from '@/utils'
import md5 from 'js-md5'
import user from '@api/login'
import compareVipRight from '@components/common/compareVipRight.js'
import MyCollection from './components/MyCollectionOrder'
import PasswordDialog from './components/PasswordDialog'
import UserInfo from './components/UserInfo'
import mobileInvoiceList from '@components/personalPage/components/MobileInvoiceList'

export default {
  name: 'PcPage',
  mixins: [compareVipRight],
  data() {
    return {
      userName: '11111',
      headPic: '',
      currentModule: 'collect',
      invoiceListTitle: ''
    }
  },
  components: { UserInfo, PasswordDialog, MyCollection, mobileInvoiceList },
  computed: {
    isMobile() {
      return this.$store.state.book.isMobile
    }
  },
  methods: {
    changeModule(val) {
      this.currentModule = val
    },
    getUserInfo() {
      user.getUserInfo().then((res) => {
        let data = res.data
        if (data.data) {
          this.userName = data.data.username
          this.headPic = data.data.picture
          if (this.isMobile) {
            this.$refs.userInfo.userName = this.userName
            this.$refs.userInfo.headPic = this.headPic
          }
        }
      })
    },
    uploadPhoto(e) {
      let file = e.target.files[0]
      let params = new FormData()
      params.append('uploadFile', file)
      user.modifyHeadPicture(params).then((res) => {
        let data = res.data
        if (data.status === 0 && data.data) {
          this.headPic = data.data.headPicture
          if (this.isMobile) {
            this.$refs.userInfo.headPic = this.headPic
          }
          this.$message({
            message: '修改成功',
            type: 'success'
          })
        } else {
          e.target.value = ''
          this.$message({
            message: data.message || '修改失败',
            type: 'error'
          })
        }
      })
    },
    changeUserName(userName) {
      let name = userName ? userName : this.$refs.nameSpan.innerText
      user.modifyName(name).then((res) => {
        let data = res.data
        if (data.status === 0 && data.data) {
          this.userName = data.data.userName
          this.$message({
            message: '修改成功',
            type: 'success'
          })
        } else {
          e.target.value = ''
          this.$message({
            message: data.message || '修改失败',
            type: 'error'
          })
        }
      })
    },
    changePassword() {
      this.$refs.passwordDialog.dialogVisible = true
    },
    savePassword(origin, newPassword) {
      let param = {
        oldPassword: md5(origin),
        newPassword: md5(newPassword)
      }
      user.modifyPassword(param).then((res) => {
        let data = res.data
        if (data.status === 0) {
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          if (!this.isMobile) {
            this.$refs.passwordDialog.dialogVisible = false
          } else {
            this.$refs.userInfo.isPassword = false
          }
        } else {
          this.$message({
            message: data.message || '修改失败',
            type: 'error'
          })
        }
      })
    },
    changeInfo() {
      this.currentModule = 'userInfo'
    },
    logout() {
      this.$emit('logout')
    }
  },
  created() {
    isLogin()
    this.getUserInfo()
    this.getVipInfo()
  }
}
</script>
<style lang="scss">
.personal-management {
  padding: 15px 0 15px 30px;
  .header {
    background: #fafafa;
    border-radius: 5px;
    border: 1px solid #eaeaea;
    height: 101px;
    padding: 18px 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-right: 30px;
    .user-info {
      font-size: 18px;
      font-weight: 600;
      display: flex;
      align-items: center;
      img {
        width: 60px;
        height: 60px;
        margin-right: 5px;
        cursor: pointer;
        border-radius: 30px;
      }
      .name {
        .name-input {
          font-size: 18px;
          font-weight: 600;
          display: inline-block;
          width: auto;
          border: none;
          :focus {
            border: 1px solid #dcdfe6;
            border-radius: 4px;
          }
        }
        margin-right: 10px;
      }
      .head-button {
        width: 56px;
        height: 25px;
        background: #df5813;
        border-radius: 3px;
        font-size: 14px;
        color: #fff;
        padding: 0;
        line-height: 25px;
      }
    }
    .navbar {
      li {
        display: inline-block;
        margin-right: 35px;
        cursor: pointer;
        font-size: 14px;
        font-weight: 400;
        color: #515151;
      }
      li.active {
        color: #df5813;
      }
    }
  }
  .personal-management-content {
    margin-top: 20px;
    display: flex;
    .side-bar {
      .collect-bar {
        width: 225px;
        height: 51px;
        border-radius: 5px;
        text-align: center;
        color: #3a3a3a;
        font-size: 18px;
        padding: 13px 0;
        background-color: #fafafa;
        cursor: pointer;
        vertical-align: middle;
        img {
          width: 20px;
          height: 20px;
          margin: auto 10px auto 0;
        }
        &.active {
          background-color: #df5813;
          color: #ffffff;
        }
      }
    }
    .content {
      padding-left: 25px;
      width: 100%;
    }
  }
}
.personal-mobile {
  width: 100%;
  height: 100vh;
  position: relative;
  .header {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 0;
    .title {
      background-color: #f5f5f5;
      text-align: center;
      height: 46px;
      font-size: 16px;
      font-weight: 600;
      color: #000000;
      line-height: 45px;
      width: 100%;
      padding: 0 20px;
    }
    .user-info {
      background-color: #f5f5f5;
      font-size: 18px;
      font-weight: 600;
      padding: 20px 0;
      width: 100%;
      text-align: center;
      .head-pic {
        width: 100px;
        height: 100px;
        border-radius: 50px;
      }
      img {
        max-width: 120px;
      }
    }
    .navbar {
      width: 100%;
      text-align: center;
      padding: 0 20px;
      li {
        height: 60px;
        line-height: 60px;
        font-size: 16px;
      }
    }
  }
  .mobile-button {
    position: fixed;
    bottom: 0;
    display: flex;
    width: 100%;
    justify-content: space-evenly;
    box-shadow: 0px 2px 5px 0px #cecece;
    height: 75px;
    z-index: 99;
    background-color: #fff;
    .button-item {
      text-align: center;
      .icon-wrapper {
        img {
          width: 45px;
        }
      }
    }
  }
  .content {
    height: 100%;
  }
  .border_bottom {
    border-bottom: #eaeaea 1px solid;
  }
}
</style>
